import { generateClient } from "aws-amplify/api";
const client = generateClient();
import { list_master_medication_categories } from "@/graphql/queries";

export default {
  data() {
    return {
      medicationCategoriesList: [],
    };
  },
  methods: {
    async fetchMedicationCategories(input = {}) {
      try {
        const response = await client.graphql({
          query: list_master_medication_categories,
          variables: {
            input,
          },
        });

        const responseData = JSON.parse(
          response.data.list_master_medication_categories
        );
        if (responseData.status == "SUCCESS") {
          this.medicationCategoriesList = (responseData.data || []).filter(
            (item) => item.medication_category_status !== "DEACTIVE"
          );
        } else {
          this.medicationCategoriesList = [];
        }
      } catch (error) {
        console.error("Error fetching medication categories:", error);
        if (error == "NoValidAuthTokens: No federated jwt") {
          this.$router.push("/login");
          this.$store.dispatch("logout");
          this.$store.dispatch("clearAuth");
          this.$store.dispatch("clearUser");
          this.$store.dispatch("clearToken");
          this.$store.dispatch("clearRefreshToken");
          this.$store.dispatch("clearExpiresAt");
          this.$store.dispatch("clearExpiresIn");
        }
        this.medicationCategoriesList = [];
        throw error;
      }
    },
  },
};
